// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"22":"85b222f84e53951e","85":"9e63fcbfe3b21cb3","370":"af0189327b58aff9"}[chunkId] + ".js";
};